import {
  ThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material/styles";
import { MobileDateTimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { getMaxDate, getMinDate } from "../../constants/dateFunctions";
import { TextField } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "Proximanova Reg, sans-serif",
    button: {
      textTransform: "none",
      borderRadius: "5px",
    },
  },
  components: {
    // * current tab
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "white",
          },
        },
      },
    },
    // * controls styles for both tabs
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "red",
          height: 3,
        },
      },
    },
    // * Displays the selected date
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: "#3f51b5",
          "& .MuiTypography-root": {
            color: "white",
          },
        },
      },
    },
    // * tabs allow switching between day and time
    MuiDateTimePickerTabs: {
      styleOverrides: {
        root: {
          backgroundColor: "#3f51b5",
        },
      },
    },
  },
});

const DatePickers = (props) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <MobileDateTimePicker
          label={props.label}
          className={props.class}
          value={props.displayDate ? props.displayDate : null}
          ampm={false}
          inputFormat={"MM-DD-YYYY LT"}
          onChange={(date) => props.handleDateChange(date)}
          maxDate={getMaxDate()}
          minDate={getMinDate()}
          renderInput={(params) => (
            <TextField
              name={props.name}
              {...params}
              variant="standard"
              helperText={props.dateHelperText}
            />
          )}
        />
      </LocalizationProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);

export default DatePickers;
